import React from 'react'
import styled from '@emotion/styled'
import { FaRegAddressCard as IdCard } from 'react-icons/fa'
import { CartBreakdownItem } from '../CartBreakdown'

const AlcoholNote: React.FC = () => {
  const copy = `You are ordering products that contain alcohol. Please ensure you have ID when receiving your order.`
  return (
    <CartBreakdownItem
      label='ID Required'
      LeftIcon={IdCard}
      fontWeight={500}
      fontSize={16}
      labelMargin={'8px 0 8px 0'}
      withLineBreak={false}
    >
      <Note style={{ color: '#59595A' }}>{copy}</Note>
    </CartBreakdownItem>
  )
}

const Note = styled.div(() => ({
  color: '#59595A',
  fontSize: 14
}))

export default AlcoholNote
